import { CButton } from '@coreui/react-pro'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { getVisitDiagnosis, submitDiagCodes } from 'src/helper/backendHelper'
import { getPCCConditions } from 'src/helper/pccApiHelper'
import Loader from 'src/components/common/Loader/Loader'

PullFromFacility.propTypes = {
  setSelectedDiagnosis: PropTypes.any.isRequired,
  patientId: PropTypes.string,
  visitId: PropTypes.string,
}

export default function PullFromFacility({ patientId, visitId, setSelectedDiagnosis, dos }) {
  const [isLoading, setLoading] = useState(false)

  const pullDiagnosis = async () => {
    setLoading(true)
    const results = await getPCCConditions(patientId, dos)
    if (results && results.length > 0) {
      let selected = results
        .filter((c) => c.clinicalStatus === 'ACTIVE')
        .map((c) => c.icd10.replaceAll('.', ''))
      await submitDiagCodes(visitId, { diagnosis_codes: selected })
      const diagnosisList = await getVisitDiagnosis(visitId)
      if (diagnosisList?.results) {
        setSelectedDiagnosis(diagnosisList?.results)
      }
    }
    setLoading(false)
  }

  return (
    <div>
      {isLoading && <Loader />}
      <CButton color="primary" onClick={() => pullDiagnosis()}>
        Pull from Facility
      </CButton>
    </div>
  )
}
